import script from "./CustomModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomModal.vue?vue&type=style&index=0&id=4fd0d5b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd0d5b8"]])

export default __exports__